import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import SeaBookingBasic from './seaBookingModule/seaBookingBasic'
import SeaBookingVessel from './seaBookingModule/seaBookingVessel'
import SeaBookingMbl from './seaBookingModule/seaBookingMbl'
import SeaBookingHbl from './seaBookingModule/seaBookingHbl'
import SeaBookingVirtualHbl from './seaBookingModule/seaBookingVirtualHbl'
import AirBookingBasic from './airBookingModuel/airBookingBasic'
import AirBookingVessel from './airBookingModuel/airBookingVessel'

export default class CustomFormElementManager {
  constructor(job, getPageFormData) {
    this.job = job
    this.pageDict = {}
    this.refreshId = 0 // 强制刷新id
    this.getPageFormData = getPageFormData
  }

  getPage(pageType) {
    let page = this.pageDict[pageType]
    if (!page) {
      switch (pageType) {
        case UICustomConstants.SEA_BOOKING_BASIC:
          page = new SeaBookingBasic(this.job, this.getPageFormData(pageType))
          break
        case UICustomConstants.SEA_BOOKING_VESSEL:
          page = new SeaBookingVessel(this.job, this.getPageFormData(pageType))
          break
        case UICustomConstants.SEA_BOOKING_MBL:
          page = new SeaBookingMbl(this.job, this.getPageFormData(pageType))
          break
        case UICustomConstants.SEA_BOOKING_HBL:
          page = new SeaBookingHbl(this.job, this.getPageFormData(pageType))
          break
        case UICustomConstants.SEA_BOOKING_VIRTUAL_HBL:
          page = new SeaBookingVirtualHbl(this.job, this.getPageFormData(pageType))
          break
        case UICustomConstants.AIR_BOOKING_BASIC:
          page = new AirBookingBasic(this.job, this.getPageFormData(pageType))
          break
        case UICustomConstants.AIR_BOOKING_VESSEL:
          page = new AirBookingVessel(this.job, this.getPageFormData(pageType))
          break
      }
      if (page) {
        this.pageDict[pageType] = page
      }
    }
    return page
  }

  async loadElement(pageType, elementName) {
    const page = this.getPage(pageType)
    if (!page) {
      return null
    }
    return await page.loadElement(elementName)
  }

  get(pageType, elementName) {
    const page = this.getPage(pageType)
    if (!page) {
      return null
    }
    return page.get(elementName)
  }

  async handlePageFieldChange() {
    let hasChange = false
    for (const key in this.pageDict) {
      const item = this.pageDict[key]
      if (item && await item.handleFieldChange()) {
        hasChange = true
      }
    }
    if (hasChange) {
      this.refreshId++
    }
  }

  async updateJob(job) {
    this.job = job
    let hasChange = false
    for (const key in this.pageDict) {
      const item = this.pageDict[key]
      item.job = job
      item.formData = this.getPageFormData(Number(key))
      if (await item.triggerAllChange()) {
        hasChange = true
      }
    }
    if (hasChange) {
      this.refreshId++
    }
  }

  async updateFormData() {
    let hasChange = false
    for (const key in this.pageDict) {
      const item = this.pageDict[key]
      item.formData = this.getPageFormData(Number(key))
      if (await item.triggerAllChange()) {
        hasChange = true
      }
    }
    if (hasChange) {
      this.refreshId++
    }
  }
}
